import {
  DefaultApi,
  GetTooltipDto,
  CreateUpdateTooltipDto,
  GetLastEditorDto,
} from '../autogenerated/pokApiClient';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import { TooltipSchema } from '../validation/schemas';
import { validateAgainst } from '../validation/validateAgainst';
import { tooltipForGrid } from '../../../pok/components/Tooltips/TooltipSearch';

export interface TooltipContextInterface {
  getAll: () => Promise<GetTooltipDto[]>;
  getAllByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
  ) => Promise<GridRecord[]>;
  getAllCount: (filterText?: string, filterColumns?: string) => Promise<number>;
  getById: (id: string) => Promise<GetTooltipDto>;
  update: (id: string, dto: CreateUpdateTooltipDto) => Promise<void>;
  getLastEditor: (id: string) => Promise<GetLastEditorDto>;
}

export const TooltipContext = (api: DefaultApi): TooltipContextInterface => {
  return {
    getAll: () => api.tooltipControllerGetAll(),
    getAllByPortion: async (
      pageSize,
      pageNumber,
      orderBy,
      orderDirection,
      filterText,
      filterColumns,
    ) => {
      const data = await api.tooltipControllerGetAllByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
        filterColumns,
      );
      return data.map(tooltipForGrid);
    },
    getAllCount: (filterText, filterColumns) =>
      api.tooltipControllerGetAllCount(filterText || '', filterColumns),
    getById: (id: string) => api.tooltipControllerGet(id),
    update: (id: string, dto: CreateUpdateTooltipDto) =>
      api.tooltipControllerUpdate(id, dto),
    getLastEditor: (id: string) => api.tooltipControllerGetLastEditor(id),
  };
};

export const validate = (dto: CreateUpdateTooltipDto) =>
  validateAgainst(TooltipSchema, dto);

export const convert = (tooltip: GetTooltipDto): CreateUpdateTooltipDto => ({
  description: tooltip.description,
  plText: tooltip.plText,
  enText: tooltip.enText,
});
